var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoChartData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 396,
    height: 204.748,
    viewBox: "0 0 396 204.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 396,
    height: 204.748,
    rx: 10,
    transform: "translate(11838 492.248) rotate(180)",
    fill: "none",
    stroke: "#13344d",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.896,
    y1: -0.947,
    x2: 0.5,
    y2: 0.964,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2197ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2197ed",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1445",
    "data-name": "Group 1445",
    transform: "translate(3431 12704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1444",
    "data-name": "Group 1444",
    transform: "translate(-4406 -13220.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(0 -0.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(-8554 585.305)",
    opacity: 0.379
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(-1913 -355.748)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 396,
    height: 204.748,
    rx: 10,
    transform: "translate(11838 492.248) rotate(180)",
    fill: "#005ea2",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M-19726.043-4298.053l2.152-3.314,1.318,4.418,3.51-6.628,3.066,9.942,5.7,2.762,4.82,4.971h5.92l1.535-6.628,7.893,5.248h4.824l2.852-2.485,2.629,2.485,13.154-10.771,3.289,4.419,2.193-4.419,3.945,2.762,4.387-8.285,3.07,5.523,3.066-15.19,3.512,14.085,2.629-7.733,6.8,8.838,2.41-5.523,7.455,8.285,8.553-1.657,4.383-6.628,3.73,6.628,4.6-1.1,4.164-18.781,5.7,11.6,3.506-20.438,3.729-5.248,1.094,5.248,2.633,2.762,5.7,16.019,8.33,9.943,2.852-2.209,1.973,2.209,4.164-6.628,1.977,9.942,7.012,3.867,3.289,3.866h5.484l3.289-6.628,10.742,6.628,7.453-1.381,5.48-6.353,3.508-7.733,5.92,4.418,3.947-6.628,1.973,4.418,3.945-4.418,6.8,4.418,1.973-6.076,4.6,8.286,4.387,1.657h2.629l3.73-11.6,2.848,3.315,1.973-14.915,5.7-3.314,2.635,3.314,6.357-16.295,3.727,4.971,1.1,9.667,4.164,3.314,1.754-4.971,2.85,6.9h3.289l2.85-1.934,3.07-8.838,3.07-4.143,2.85,6.905,3.729,1.1,1.533-2.486,3.291,2.486,5.479-6.076,3.506,3.59,2.633-13.257,2.852,9.667,2.41-4.7,7.018,6.905,2.408-4.143,7.02,6.905h7.016l5.262-3.867,5.7,3.867,3.73-1.381,4.383-18.229,5.7,11.6,3.51-20.162,3.725-5.524,1.316,5.524,3.727,2.486,4.262-8.01v163.485h-396.941v-103.828Z",
    transform: "translate(31169.438 4694.4)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M-19726.043-4298.053l2.152-3.314,1.318,4.418,3.51-6.628,3.066,9.942,5.7,2.762,4.82,4.971h5.92l1.535-6.628,7.893,5.248h4.824l2.852-2.485,2.629,2.485,13.154-10.771,3.289,4.419,2.193-4.419,3.945,2.762,4.387-8.285,3.07,5.523,3.066-15.19,3.512,14.085,2.629-7.733,6.8,8.838,2.41-5.523,7.455,8.285,8.553-1.657,4.383-6.628,3.73,6.628,4.6-1.1,4.164-18.781,5.7,11.6,3.506-20.438,3.729-5.248,1.094,5.248,2.633,2.762,5.7,16.019,8.33,9.943,2.852-2.209,1.973,2.209,4.164-6.628,1.977,9.942,7.012,3.867,3.289,3.866h5.484l3.289-6.628,10.742,6.628,7.453-1.381,5.48-6.353,3.508-7.733,5.92,4.418,3.947-6.628,1.973,4.418,3.945-4.418,6.8,4.418,1.973-6.076,4.6,8.286,4.387,1.657h2.629l3.73-11.6,2.848,3.315,1.973-14.915,5.7-3.314,2.635,3.314,6.357-16.295,3.727,4.971,1.1,9.667,4.164,3.314,1.754-4.971,2.85,6.9h3.289l2.85-1.934,3.07-8.838,3.07-4.143,2.85,6.905,3.729,1.1,1.533-2.486,3.291,2.486,5.479-6.076,3.506,3.59,2.633-13.257,2.852,9.667,2.41-4.7,7.018,6.905,2.408-4.143,7.02,6.905h7.016l5.262-3.867,5.7,3.867,3.73-1.381,4.383-18.229,5.7,11.6,3.51-20.162,3.725-5.524,1.316,5.524,3.727,2.486,4.262-8.01",
    transform: "translate(31169.438 4694.4)",
    fill: "none",
    stroke: "#2197ed",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    transform: "translate(11838 492.248) rotate(180)",
    fill: "none",
    stroke: "#13344d",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 396,
    height: 204.748,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 394,
    height: 202.748,
    rx: 9,
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1397",
    "data-name": "Group 1397",
    transform: "translate(-28.486 0.641)",
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1395",
    "data-name": "Group 1395",
    transform: "translate(1137.486 605.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109-2",
    "data-name": "Rectangle 109",
    width: 128.417,
    height: 27.321,
    rx: 6,
    transform: "translate(128.417 27.321) rotate(180)",
    fill: "#0b2e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75-2",
    "data-name": "Rectangle 75",
    width: 97.321,
    height: 27.321,
    rx: 10,
    transform: "translate(97.321 27.321) rotate(180)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1396",
    "data-name": "Group 1396",
    transform: "translate(1156.431 611.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_852",
    "data-name": "Group 852",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M5.412,0H7.37V-7.3H5.8V-2.4H5.775L3.014-7.3H.781V0H2.354V-5.423h.022Zm5.852-5.28a2.62,2.62,0,0,0-2.772,2.7A2.626,2.626,0,0,0,11.264.11a2.623,2.623,0,0,0,2.761-2.7A2.617,2.617,0,0,0,11.264-5.28Zm0,1.276a1.308,1.308,0,0,1,1.309,1.419,1.308,1.308,0,0,1-1.309,1.419,1.31,1.31,0,0,1-1.32-1.419A1.31,1.31,0,0,1,11.264-4ZM19.943-5.28a2.626,2.626,0,0,0-2.816,2.7A2.626,2.626,0,0,0,19.943.11a2.706,2.706,0,0,0,1.606-.385V-1.826h-.055a1.64,1.64,0,0,1-1.4.66,1.368,1.368,0,0,1-1.518-1.419A1.363,1.363,0,0,1,20.1-4a1.658,1.658,0,0,1,1.4.649h.055V-4.9A2.775,2.775,0,0,0,19.943-5.28Zm5.61,0a1.793,1.793,0,0,0-1.43.583H24.1v-3H22.66V0H24.1V-2.75c0-.8.4-1.254,1.067-1.254.6,0,.957.4.957,1.111V0h1.441V-3.069A1.938,1.938,0,0,0,25.553-5.28ZM33.924,0V-5.17h-1.2L32.67-4.5h-.022a1.912,1.912,0,0,0-1.672-.781,2.532,2.532,0,0,0-2.53,2.7,2.532,2.532,0,0,0,2.53,2.7,1.92,1.92,0,0,0,1.683-.8h.022L32.725,0ZM31.218-1.166A1.31,1.31,0,0,1,29.9-2.585,1.31,1.31,0,0,1,31.218-4a1.308,1.308,0,0,1,1.309,1.419A1.308,1.308,0,0,1,31.218-1.166ZM35.2,0h1.441V-7.7H35.2Zm2.717,0h1.441V-7.7H37.917Zm7.722-2.222v-.583A2.365,2.365,0,0,0,43.032-5.28a2.588,2.588,0,0,0-2.695,2.7c0,1.6,1.243,2.7,3.069,2.7a3.4,3.4,0,0,0,1.925-.484V-1.76h-.055a2.549,2.549,0,0,1-1.8.627,1.529,1.529,0,0,1-1.683-1.089ZM43.076-4.037a1.135,1.135,0,0,1,1.265.946H41.789A1.252,1.252,0,0,1,43.076-4.037ZM49.511-5.28a1.753,1.753,0,0,0-1.617.847h-.022l-.055-.737h-1.2V0h1.441V-2.75c0-.8.4-1.254,1.067-1.254.6,0,.957.4.957,1.111V0h1.441V-3.069A1.938,1.938,0,0,0,49.511-5.28Zm8.371.11h-1.2l-.044.682h-.022a1.913,1.913,0,0,0-1.683-.792A2.5,2.5,0,0,0,52.4-2.629,2.5,2.5,0,0,0,54.934.022a1.981,1.981,0,0,0,1.485-.561h.022v.033c0,.913-.583,1.43-1.617,1.43A2.444,2.444,0,0,1,52.976.187h-.055V1.639A3.514,3.514,0,0,0,55,2.2c1.793,0,2.882-1,2.882-2.618ZM55.176-1.254a1.274,1.274,0,0,1-1.32-1.375A1.274,1.274,0,0,1,55.176-4a1.271,1.271,0,0,1,1.309,1.375A1.271,1.271,0,0,1,55.176-1.254Zm8.987-.968v-.583A2.365,2.365,0,0,0,61.556-5.28a2.588,2.588,0,0,0-2.695,2.7c0,1.6,1.243,2.7,3.069,2.7a3.4,3.4,0,0,0,1.925-.484V-1.76H63.8a2.549,2.549,0,0,1-1.8.627,1.529,1.529,0,0,1-1.683-1.089ZM61.6-4.037a1.135,1.135,0,0,1,1.265.946H60.313A1.252,1.252,0,0,1,61.6-4.037ZM67.067-5.28c-1.309,0-2.156.671-2.156,1.716,0,1.023.517,1.419,1.826,1.54.726.066.946.176.946.451,0,.33-.275.5-.836.5a2.379,2.379,0,0,1-1.826-.66h-.066V-.352A3.432,3.432,0,0,0,66.913.11c1.331,0,2.123-.627,2.123-1.683,0-1.089-.539-1.573-1.914-1.661-.682-.044-.858-.143-.858-.374,0-.319.275-.484.836-.484a2.117,2.117,0,0,1,1.54.517h.055V-4.95A3.725,3.725,0,0,0,67.067-5.28Zm7.238,7.37,2.959-7.26H75.779l-1.2,3.41h-.022l-1.21-3.41h-1.54L73.8-.165,72.82,2.09Zm8.481-4.312v-.583A2.365,2.365,0,0,0,80.179-5.28a2.588,2.588,0,0,0-2.695,2.7c0,1.6,1.243,2.7,3.069,2.7a3.4,3.4,0,0,0,1.925-.484V-1.76h-.055a2.549,2.549,0,0,1-1.8.627,1.529,1.529,0,0,1-1.683-1.089ZM80.223-4.037a1.135,1.135,0,0,1,1.265.946H78.936A1.252,1.252,0,0,1,80.223-4.037Zm6.809,2.574h-.055a.932.932,0,0,1-.726.3.676.676,0,0,1-.715-.77V-3.949h1.485V-5.17H85.536V-6.622h-1.21L84.139-5.17h-.9v1.221h.858v2.068A1.751,1.751,0,0,0,86.02.11a2.321,2.321,0,0,0,1.012-.176Z",
    transform: "translate(0.366 10.382)",
    fill: "#3797ed"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChartData);
export default __webpack_public_path__ + "static/media/noChartData.569573faae1e54484b25b803eae424c5.svg";
export { ForwardRef as ReactComponent };